(() => {
  function lineIcon(name) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [key, value] of Object.entries({class:'veryo-icon icon-'+name,width:'20',height:'20',viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.7','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) svg.setAttribute(key,value);
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', name === 'star' ? 'm12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z' : 'M5 7h14l1 14H4L5 7Z M8 8V6a4 4 0 0 1 8 0v2');
    svg.append(path);
    return svg;
  }
  function updateAddButton(button, available) {
    button.replaceChildren(document.createTextNode(available ? 'Add to bag' : 'Sold out'));
    if (available) button.append(lineIcon('bag'));
  }
  function init(scope = document) {
    const reviews = document.querySelector('[data-review-total]');
    if (reviews && Number(reviews.dataset.reviewTotal) > 0) {
      document.querySelectorAll('[data-review-link]').forEach(link => {
        link.replaceChildren(lineIcon('star'), document.createTextNode(reviews.dataset.reviewAverage + ' / 5 · ' + reviews.dataset.reviewTotal + ' reviews'));
      });
    }
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      section.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
        const image = section.querySelector('[data-main-image]');
        image.src = button.dataset.gallerySrc;
        image.alt = button.dataset.alt;
        section.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const form = section.querySelector('.product-form');
      if (!form) return;
      const select = form.querySelector('[data-variant-select]');
      const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
      const quantity = form.querySelector('[name="quantity"]');
      const add = form.querySelector('[data-add]');
      const status = form.querySelector('[data-product-status]');
      const success = form.querySelector('[data-cart-success]');
      const clamp = () => quantity.value = Math.min(99, Math.max(1, Math.floor(Number(quantity.value) || 1)));
      form.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {quantity.value = Number(quantity.value) + Number(button.dataset.quantity);clamp();}));
      quantity.addEventListener('change', clamp);
      function updateVariant() {
        const variant = variants.find(v => String(v.id) === select.value);
        if (!variant) return;
        section.querySelector('[data-price]').textContent = variant.priceLabel;
        const compare = section.querySelector('[data-compare]');
        const sale = section.querySelector('[data-sale]');
        const discounted = variant.compare > variant.price;
        compare.hidden = sale.hidden = !discounted;
        compare.textContent = variant.compareLabel;
        sale.textContent = discounted ? Math.round((variant.compare - variant.price) / variant.compare * 100) + '% OFF' : '';
        add.disabled = !variant.available;
        updateAddButton(add, variant.available);
        status.textContent = '';
        success.hidden = true;
        section.querySelectorAll('[data-gallery-src]')[0]?.click();
      }
      const requested = new URL(location.href).searchParams.get('variant');
      if (requested && variants.some(v => String(v.id) === requested)) {select.value = requested;updateVariant();}
      select.addEventListener('change', () => {
        updateVariant();
        if (location.pathname.includes('/products/')) {const url = new URL(location.href);url.searchParams.set('variant', select.value);history.replaceState({}, '', url);}
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (add.disabled) return;
        clamp();add.disabled = true;add.textContent = 'Adding…';status.textContent = '';success.hidden = true;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:Number(quantity.value)}]})});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this option. Please try again.');
          status.textContent = 'Added to your bag.';success.hidden = false;
          try {const cartResponse = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}});if(cartResponse.ok){const cart = await cartResponse.json();const bag = document.querySelector('.bag');bag.querySelector('span').textContent = 'Bag (' + cart.item_count + ')';bag.setAttribute('aria-label','Shopping bag, '+cart.item_count+' items');}} catch (_) {}
        } catch (error) {status.textContent = error.message || 'Connection problem. Please try again.';}
        finally {const selected = variants.find(v => String(v.id) === select.value);add.disabled = !selected?.available;updateAddButton(add, selected?.available);}
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
